export default "__VITE_ASSET__asaWlADV__"